import { Allergies } from 'one-state-activeallergies/src/allergies';

import { formatIso } from 'one-util-date';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Active Allergies Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */

export const sortFunction = (a: Allergies, b: Allergies) => {
    const dateA = new Date(a.dateEntered);
    const dateB =new Date(b.dateEntered);
    return dateB.getTime() - dateA.getTime();
}


export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */

    // let result: Allergies[] = [];
    let result :any = {
        allergies:[],
        error:undefined
    }

    const { log,settings } = context;
    const {uisettings:{dateformat}} = settings
    function convertString(str:any) {
        // Split the string into an array of words
        var words = str.split(" ");
        var convertedWords = [];
    
        // Iterate through each word
        for (var i = 0; i < words.length; i++) {
            var word = words[i].toLowerCase();
            // Convert the first letter of each word to uppercase
            var convertedWord = word.charAt(0).toUpperCase() + word.slice(1);
            convertedWords.push(convertedWord);
        }
    
        // Join the words back into a single string
        var convertedString = convertedWords.join(" ");
    
        return convertedString;
    }
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
     }

    if (response && response.length > 0) {
        const rs = response;
        let allergyarray: Allergies[] = [];
        rs?.map((ele: any) => {
            let allergyobj: Allergies ={
                id :"",
                allergenName:"",
                allergenDescription:"",
                dateEntered:"",
                dateNoted:"",
                reactions:"",
                reactionComment:"",
                severity:"",
                type:""
            }
            allergyobj.allergenName = convertString(ele.AllergenName);
            allergyobj.allergenDescription = ele.AllergenDescription;
            allergyobj.dateEntered = ele.DateEntered ? formatIso(ele.DateEntered,dateformat) : "";
            allergyobj.dateNoted = ele.DateNoted ? formatIso(ele.DateNoted,dateformat) : "";
            allergyobj.reactions = ele.Reactions ? ele.Reactions : "";
            allergyobj.reactionComment = ele.ReactionComment;
            allergyobj.severity = ele.Severity ? convertString(ele.Severity) : "";
            allergyobj.type = ele.Type ? ele.Type : "";
            allergyarray.push(allergyobj);
        });
        result.allergies=allergyarray;
    }
    log.debug(
        "ccw-gadget,activeallergies-nextgen",
        "activeallergies-nextgen transforamtion response ", {
        result
    });
    result.allergies.sort(sortFunction);
    return result;
}